module.exports = __webpack_public_path__ + "img/asset5.c7f1481d.png";